module.exports = __webpack_public_path__ + "img/2.a83a6b34.jpg";